<template>
    
<div class="item">

    <div class="item-thumb" :style="{backgroundImage: $util.thumbnail(thumb)}" v-if="thumb || forceThumb">

        <app-icon v-if="!thumb" name="image" />

    </div>

    <div class="item-name" v-if="name" v-on:click="$emit('edit')">{{ name }}<small v-if="subtext">{{ subtext }}</small><small v-if="date">{{ date | formatDate('Do MMMM YYYY') }}</small></div>

    <slot></slot>

    <div class="item-actions">

        <app-button v-if="sortable" :disabled="first" v-on:click.native="$emit('up')" size="small" theme="plain" icon="caret-up" />
        <app-button v-if="sortable" :disabled="last" v-on:click.native="$emit('down')" size="small" theme="plain" icon="caret-down" />

        <app-button v-on:click.native="$emit('edit')" size="small" theme="blue" icon="pencil" :text="text.edit" />
        <app-button v-on:click.native="$emit('delete')" size="small" theme="red" icon="delete" :text="text.delete" />

    </div>

</div>

</template>

<script>

export default {

    props: ['name', 'sortable', 'text', 'subtext', 'date', 'forceThumb', 'thumb', 'first', 'last']

}

</script>

<style scoped>

.item {
    border-bottom: 1px solid var(--color-grey-light);
    display: flex;
    flex-direction: row;
    transition: all 100ms linear;
    align-items: center;
}

.is-mobile .item {
    flex-wrap: wrap;
    padding: 10px;
}

.item:last-child {
    border-bottom-width: 0px;
}

.is-desktop .item:hover {
    background-color: #ddd;
}

.item-thumb {
    width: 54px;
    height: 54px;
    background-size: cover;
    background-position: 50% 50%;
    line-height: 54px;
    text-align: center;
    font-size: 24px;
    color: #999;
    border-radius: 4px 0px 0px 4px;
}

.is-mobile .item-thumb {
    border-radius: 4px;
    margin-right: 10px;
}

.item-name {
    padding: 0px 15px;
    flex-grow: 1;
    line-height: 14px;
    font-size: 14px;
    font-weight: 700;
    color: var(--color-grey-dark);
    cursor: pointer;
    transition: all 100ms linear;
    flex-basis: 0;
}

.is-mobile .item-name {
    padding: 0px 0px 0px 0px;
}

.item-name small {
    font-size: 11px;
    margin-top: 2px;
    display: block;
    line-height: 11px;
}

.item-actions {
    padding: 15px;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
}

.is-mobile .item-actions {
    width: 100%;
    justify-content: flex-end;
    padding: 5px 0px 0px 0px;
}

.item-actions >>> .button {
    margin-left: 5px;
    margin-bottom: 0px!important;
}

.item-actions >>> .button:first-child {
    margin-left: 0px;
}

</style>